import axios from './base'
const url = `/tower`

// ================= 塔林介绍板块管理（后端 TowerService，mg_tower_sections，/tower*） =================
// 产品规则：板块化图文，banner/intro/culture/service 四块位置固定；其余内容块一行一个可调序
// key 存字典 tower_section 的英文编码 value（banner/intro/...），同 key 唯一；status=0 隐藏后小程序主页不展示

// 板块列表（全量，无分页，sort 升序；固定块展示顺序由前端按 key 重排）
export function getTowerList(params = {}) {
  return axios.request({
    url: `${url}`,
    method: "get",
    params,
  })
}

// 板块详情
export function getTowerDetail(id, params = {}) {
  return axios.request({
    url: `${url}/${id}`,
    method: "get",
    params,
  })
}

// 新增板块（sort 不传默认排在最后；key 为字典 tower_section 的英文编码）
export function createTower(data = {}) {
  return axios.request({
    url: `${url}`,
    method: "post",
    data,
  })
}

// 编辑板块
export function updateTower(id, data = {}) {
  return axios.request({
    url: `${url}/${id}`,
    method: "put",
    data,
  })
}

// 删除板块（软删）
export function deleteTower(id, data = {}) {
  return axios.request({
    url: `${url}/${id}`,
    method: "delete",
    data,
  })
}

// 显示 / 隐藏（data: { status: 1 }）
export function setTowerStatus(id, data = {}) {
  return axios.request({
    url: `${url}/${id}/status`,
    method: "put",
    data,
  })
}

// 上移 / 下移（data: { direction: 'up' | 'down' }；仅非固定板块，固定块后端拒绝）
export function moveTower(id, data = {}) {
  return axios.request({
    url: `${url}/${id}/move`,
    method: "put",
    data,
  })
}
